import { FC } from 'react';
import { Box } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

interface EditNavBarProp {
  editMode: boolean;
  editModeToggle: () => void;
  formName: string;
  flexGrow?: number;
  isPrimary?: boolean;
}

export const EditNavBar: FC<EditNavBarProp> = ({ editMode, editModeToggle, formName, flexGrow, isPrimary = true }) => {
  if (editMode) {
    return (
      <Box display="flex" gap="16px">
        <Button color="tertiary" onClick={editModeToggle}>
          Cancel
        </Button>
        <Button form={formName} color="primary" variant="contained" size={isPrimary ? 'large' : 'small'} type="submit">
          Save
        </Button>
      </Box>
    );
  }

  return (
    <Box flexGrow={typeof flexGrow === 'undefined' ? 20 : flexGrow} ml="auto">
      <Button color={isPrimary ? 'primary' : 'secondary'} size={isPrimary ? 'large' : 'small'} onClick={editModeToggle}>
        Edit
      </Button>
    </Box>
  );
};
